import { useEffect } from "react";
import { Dashboard } from "@/components/Dashboard";
import { useOrganization } from "@/hooks/useOrganization";

const CustomerDashboardPage = () => {
  const { currentOrganization, loading } = useOrganization();

  useEffect(() => {
    document.title = "Customer Dashboard | Shohnat";
    const metaDesc = document.querySelector('meta[name="description"]') || (() => {
      const m = document.createElement('meta');
      m.setAttribute('name', 'description');
      document.head.appendChild(m);
      return m;
    })();
    metaDesc.setAttribute('content', 'Customer dashboard to create loads, manage carriers, and track shipments.');
  }, []);

  if (loading || !currentOrganization) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary" aria-label="Loading customer dashboard"></div>
      </div>
    );
  }

  const companyName = currentOrganization.organization_name || 'My Company';

  return (
    <main>
      <Dashboard companyName={companyName} />
    </main>
  );
};

export default CustomerDashboardPage;
